import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LanguageService } from '../../services/language.service';
import { Subscription, combineLatest } from 'rxjs';

@Component({
  selector: 'app-about-us',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './about-us.html',
  styleUrls: ['./about-us.scss']
})
export class AboutUsComponent implements OnInit, OnDestroy {
  currentLanguage = 'en';
  private subscriptions: Subscription[] = [];

  constructor(private languageService: LanguageService) {}

  ngOnInit(): void {
    // Subscribe to both language and translations changes
    // This ensures UI updates when translations load after page refresh
    this.subscriptions.push(
      combineLatest([
        this.languageService.currentLanguage$,
        this.languageService.translations$
      ]).subscribe(([language]) => {
        this.currentLanguage = language;
      })
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach(sub => sub.unsubscribe());
  }

  translate(key: string): string {
    return this.languageService.translate(key);
  }

  // Alias for easier use in template
  t(key: string): string {
    return this.translate(key);
  }
}
